import type { ReactNode } from "react";

type PdfChipProps = {
  children: ReactNode;
  dark?: boolean;
  size?: "xs" | "sm" | "md";
  className?: string;
};

function chipLabel(children: ReactNode): string {
  if (typeof children === "string") {
    return children.toUpperCase();
  }
  return String(children);
}

/**
 * Pill badge for PDF export.
 * Table-cell vertical-align is the most reliable centering method in Playwright print PDFs.
 */
export function PdfChip({ children, dark = false, size = "sm", className = "" }: PdfChipProps) {
  return (
    <span
      className={[
        "pdf-chip",
        `pdf-chip--${size}`,
        dark ? "pdf-chip--dark" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="pdf-chip__cell">
        <span className="pdf-chip__text">{chipLabel(children)}</span>
      </span>
    </span>
  );
}
